import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { getLocalStorageStatus } from "@app/redux/apply/apply.selectors";
import {
  setFromLocalStorage,
  deleteLocalStorage,
} from "@app/redux/apply/apply.actions";

export const LocalStorageHandler = () => {
  const dispatch = useDispatch();

  const isLocalStorageChecked = useSelector(getLocalStorageStatus);

  React.useEffect(() => {
    if (!isLocalStorageChecked) {
      dispatch(setFromLocalStorage());
    }

    return () => {
      dispatch(deleteLocalStorage());
    };
  }, [isLocalStorageChecked]);

  return null;
};
